module.exports = __webpack_public_path__ + "media/images/landing/cyber/security-privacy-99521e0ca4425056b2e430abc425d752.png";